(function () {
  angular
    .module('MktzapApp.Controllers')
    .requires
    .push(
      'ngTable'
    );

  angular.module('MktzapApp.Controllers')
    .controller('ReportsAutoHistoryClassifiedController', reports);

  reports.$inject = ['$scope', '$http', 'NotificationService'];

  function reports ($scope, $http, NotificationService) {
    var vm = this;
    $scope.vm = vm;

    vm.loading = false;

    vm.filters = {
      fromDate: moment().startOf('month').format('DD/MM/YYYY'),
      toDate: moment().endOf('month').format('DD/MM/YYYY')
    };

    vm.dateSelected = function (type, date) {
      if (type == 'from') {
        vm.pkadayToDate.setMinDate(date);
      }
      if (type == 'to') {
        vm.pkadayFromDate.setMaxDate(date);
      }
    };

    vm.countMessages = function (lines) {
      var total = lines[lines.length - 1];
      var sum = 0;
      for (var i = 1; i < total.length; i++) {
        sum += parseInt(total[i]);
      }
      return sum;
    };

    vm.download = function (isSearch) {
      $http.get(apiUrl + '/reports/common/AutoHistoryClassified', {
        params: {
          filters: vm.filters
        }
      })
        .then(function ({ data, status, headers, config }) {
          if (data.success === false) {
            NotificationService.errorHandler(data, data.error_message);
            return false;
          }

          if (data.indexOf('no_records') >= 0) {
            vm.data = null;
            NotificationService.warningHandler(data, 'Não há registros no período escolhido.');
            return;
          }

          if (isSearch) {
            if (data.success === false) {
              NotificationService.errorHandler(data, data.error_message);
              return false;
            }
            var allTextLines = data.split(/\r\n|\n/);
            var headers = allTextLines[1].split(',');
            var header = [];
            for (var x = 0; x < headers.length; x++) {
              header.push(headers[x].replace(/["]/g, ''));
            }
            var lines = [];
            for (var i = 0; i < allTextLines.length; i++) {
              if (i > 1) {
                var data = allTextLines[i].split(',');
                if (data.length == header.length) {
                  var tarr = [];
                  for (var j = 0; j < header.length; j++) {
                    tarr.push(data[j].replace(/["]/g, ''));
                  }
                  lines.push(tarr);
                }
              }
            }
            if (lines.length === 0) {
              vm.result = 'no_messages';
            } else {
              var sum = vm.countMessages(lines);
              if (sum === 0) {
                vm.result = 'no_messages';
              } else {
                vm.result = lines.length;
              }
            }
            vm.headers = header;
            vm.data = lines;
          } else {
            var filename = headers('Mktzap-Filename') || 'relatorio-classificacao-automatica.csv';

            var anchor = angular.element('<a/>');
            anchor.css({ display: 'none' });
            angular.element(document.body).append(anchor);

            var blob = new Blob([data], { type: 'text/csv' });
            var csvUrl = URL.createObjectURL(blob);

            anchor.attr({
              href: csvUrl,
              target: '_self',
              download: filename
            })[0].click();

            anchor.remove();
            URL.revokeObjectURL(csvUrl);
          }
        }, function ({ data }) {
          NotificationService.errorHandler(data, 'Erro ao gerar relatório.');
        })
    };
  }
})();
